export default __webpack_public_path__ + "static/media/check-authorizations-en.20d03214.png";